import React from "react";
import { makeStyles } from "@material-ui/core";
import AddCommentIcon from '@material-ui/icons/AddComment';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import { factoryActive } from "../../../../Constantes/factoryActive";

const useStyles = makeStyles((theme) => ({
    button:{
        position: "absolute",
        top: 0,
        padding: 0,
        marginLeft: 12,
        marginRight: 12 
    },
    iconButton: {
      fontSize: 30,
  },
  iconButtonLeft:{
    marginTop: -3,
    fontSize: 26
  },
  buttonRight:{
    position: "absolute",
    top: 0,
    padding: 0,
    marginLeft: 12,
    marginRight: 12,
    right: 0
  }
}));

function FactoryMenu(props){
    const {processId, showForms, disabledButtom, showAddFactoryCommentForm, showAdvanceFactoryCaseForm, showRegressFactoryCaseForm, disabledRegressCase} = props;
    const classes = useStyles();    
    
    return(
      factoryActive?
      <div style={{flexGrow: 0, display: "flex", justifyContent: "flex-start"}}>
          <div style={{backgroundColor: showAdvanceFactoryCaseForm? "#c4e2f7" :'' }} onClick={disabledButtom.advanceFactoryCase  || !processId ? ()=>{} : () => showForms("advanceFactoryCase")} className={disabledButtom.advanceFactoryCase || !processId  ? "caseform-nav-factory" : "caseform-nav-factory active"} role="button" title={"Avanzar Caso Fábrica"}><SkipNextIcon classes={{root: classes.iconButton}} htmlColor={processId && !disabledButtom.advanceFactoryCase ? "#3B5158" : "#a0b8cd"} /></div>
          <div style={{backgroundColor: showAddFactoryCommentForm ? "#c4e2f7" :'' }} onClick={disabledButtom.addFactoryComment || !processId ? ()=>{} : () => showForms("addFactoryComment")} className={disabledButtom.addFactoryComment || !processId ? "caseform-nav-factory" : "caseform-nav-factory active"} role="button" title={"Añadir comentario Fábrica"}><AddCommentIcon htmlColor={processId ? "#3B5158" : "#a0b8cd"} /></div>
          <div style={{backgroundColor: showRegressFactoryCaseForm? "#c4e2f7" :'' }} onClick={disabledRegressCase || !processId ? ()=>{} : () => showForms("regressFactoryCase")} className={disabledRegressCase || !processId? "caseform-nav-factory" : "caseform-nav-factory active"} role="button" title={"Retroceder Caso Fábrica"}><SkipPreviousIcon classes={{root: classes.iconButton}} htmlColor={processId && !disabledRegressCase ? "#3B5158" : "#a0b8cd"}  /></div>
      
      </div>
      :
      <div style={{flexGrow: 0, display: "flex", justifyContent: "flex-start"}}>
      <div className={"caseform-nav-factory"} role="button" title={"Avanzar Caso Fábrica"}><SkipNextIcon classes={{root: classes.iconButton}} htmlColor="#a0b8cd" /></div>
      <div className={ "caseform-nav-factory"} role="button" title={"Añadir comentario Fábrica"}><AddCommentIcon htmlColor="#a0b8cd" /></div>
      <div className={ "caseform-nav-factory"} role="button" title={"Retroceder Caso Fábrica"}><AddCommentIcon htmlColor="#a0b8cd" /></div>

      </div>
    )
}
export {FactoryMenu}